import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
export var ContentBeforeContainer = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 40px;\n    margin-top: -1px;\n"])));
//# sourceMappingURL=ContentBeforeContainer.js.map